import { UserRole } from "models/authUser";

export type Route = {
  path: string;
  name: "dashboard" | "clients" | "sellers" | "campaigns" | "reports" | "leads" | "plans";
  icon: string;
};

export const getRoutes = (
  role: UserRole | undefined,
  active: boolean | undefined,
  userId: string | undefined
): Route[] => {
  if (!role || !userId) {
    return [];
  }

  if (!active) {
    return [
      {
        path: "/",
        name: "dashboard",
        icon: "dashboard",
      },
    ];
  }

  if (role === "admin") {
    return [
      {
        path: "/",
        name: "dashboard",
        icon: "dashboard",
      },
      {
        path: "/clientes",
        name: "clients",
        icon: "clients",
      },
      {
        path: "/vendedores",
        name: "sellers",
        icon: "sellers",
      },
      {
        path: "/planos",
        name: "plans",
        icon: "clients",
      },
      {
        path: "/campanhas",
        name: "campaigns",
        icon: "campaigns",
      },
      {
        path: "/relatorios",
        name: "reports",
        icon: "dashboard",
      },
      {
        path: "/leads",
        name: "leads",
        icon: "leads",
      },
    ].filter((route) => {
      if (userId !== "6740dd53efe814f06f8e3a6e") {
        if (route.path === "/clientes") {
          return false
        }
      }
      return true
    }) as Route[]
  }

  if (role === "seller") {
    return [
      {
        path: "/",
        name: "leads",
        icon: "leads",
      },
    ];
  }

  return [
    {
      path: "/",
      name: "dashboard",
      icon: "dashboard",
    },
    {
      path: "/vendedores",
      name: "sellers",
      icon: "sellers",
    },
    {
      path: "/campanhas",
      name: "campaigns",
      icon: "campaigns",
    },
    {
      path: "/relatorios",
      name: "reports",
      icon: "dashboard",
    },
    {
      path: "/leads",
      name: "leads",
      icon: "leads",
    },
  ];
};
